/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend(
        {
            idAttribute: 'slug',
            defaults: {
                slug: null,
                name: null,
                title: null,
                gallery: null
            }
        },
        {
            SLUG_POSTERS: 'posters',
            SLUG_MAGNETS: 'magnets'
        }
    );
});
